<template>
    <el-dialog :visible.sync="dialogVisible" :show-close="false" class="withdraw-balance-popup" :before-close="handleClose">
        <div class="withdraw-title text-center mb-2">Вивести кошти з балансу</div>
        <div class="col-md-12 form-group">
            <div class="text-label mb-1">Сума (грн)</div>
            <input :class="['form-control', {invalid: ((!$v.withdrawSum.required && $v.withdrawSum.$error) || !$v.withdrawSum.allowedSum) }]" v-model="withdrawSum" type="number" step="1" autocomplete="off" placeholder="Введіть суму виводу">
            <small class="error" v-if="! $v.withdrawSum.minValue || ! $v.withdrawSum.maxValue">Введіть коректне значення від 0 до 100 000 грн (відповідно до суми на балансі) </small>
            <small class="error" v-else-if="!checkWithdrawSum(withdrawSum)">Сума до виведення має бути меншою ніж баланс.</small>
        </div>
        <div class="col-md-12 form-group">
            <div class="text-center" style="color: #FF7700; font-size: 10px;"><span style="padding-right: 1px; font-size: 12px;"><b>10% </b></span> від суми виводу буде утримано згідно умов співпраці.
                <br>Виплата здійснюється впродовж 3 робочих днів.</div>
            <div class="text-center mt-1 middle-title">Сумма до виведення:</div>
            <div class="calculate-sum text-center">{{ this.calculateSum(withdrawSum) }} грн</div>
        </div>
        <div class="col-md-12">
            <div class="d-flex ">
                <div class="w-100 m-auto text-center middle-title">Дані отримувача</div>
                <div class="btn-edit-recipient" :loading="isUpdate" @click="editRecipientData = true">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <rect width="18" height="18" fill="url(#pattern0_1877_82)"/>
                        <defs>
                            <pattern id="pattern0_1877_82" patternContentUnits="objectBoundingBox" width="1" height="1">
                                <use xlink:href="#image0_1877_82" transform="scale(0.02)"/>
                            </pattern>
                            <image id="image0_1877_82" width="50" height="50" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABkElEQVR4nO2Zr04DQRCHfwILAsljkOBBk+IIjvKfAqYO2WcAdzOrwGJ4AAwCQ5B9Ayo6c6IYIE1oyZZLKXBXjhpmm/2SzSV3K/bLb2/usgNEIn8j0SWwXIOlA9ZnkNyBZQNBwWkVLF2w9nPGOYKg0Z8ByX2BxMdwso4g4M48WB/GyNzCLCT7IGnB6cqvMiRPMAlpDSS9bNusDu8XyZAKTEuQ1H88z5e5QlASuTLSRSKLCE5iVGZQzdIqgpRgrYB1eViazcB6WFqCpJ7Na8EUk0n0wHoAM7DsgeUtK5+npSVIT2CGqZAg2Y0SJohJhJ5EoscwQ5SwwlQk4WQnSpjAxSSM4GISRnAxicCTYD2CGVyUMIKbhiS4vR0lTEDtrc8kSh6e+fn+F94Ml+kcSF/ClvAkujZyKFZDucOz4nn/BunZSFsrf5HmJTwkzW89uq+LDULC6cLwhDxPJggJD6WbxW3grIr5q/9ImobkYmxznvV1UJrNw/KYs62aWQGowOksgoDlZiDjk/HbzL8zkQgm5R0QN2ER7zzKHgAAAABJRU5ErkJggg=="/>
                        </defs>
                    </svg>
                </div>
<!--                <button class="btn btn-sm btn-outline-primary btn-edit btn-edit-recipient" type="button" :loading="isUpdate" @click="editRecipientData = true">-->

<!--                </button>-->
            </div>
            <div class="form-group">
                <div class="text-label my-2">Рахунок отримувача</div>
                <input :class="['form-control', { invalid: (!$v.recipientAccount.required && $v.recipientAccount.$error) || (!$v.recipientAccount.minLength ) }]" v-model="recipientAccount" type="text" :disabled="!editRecipientData">
                <small class="error" v-if="$v.recipientAccount.$dirty && !$v.recipientAccount.minLength">Введіть номер рахунку отримувача</small>
                <small class="error" v-if="$v.recipientAccount.$dirty && !$v.recipientAccount.required">Введіть номер рахунку отримувача</small>
            </div>
            <div class="form-group">
                <div class="text-label my-2">Назва банку</div>
                <input :class="['form-control', { invalid: (!$v.recipientBankName.required && $v.recipientBankName.$error) || (!$v.recipientBankName.minLength ) }]" v-model="recipientBankName" type="text" :disabled="!editRecipientData">
                <small class="error" v-if="$v.recipientBankName.$dirty && !$v.recipientBankName.minLength">Введіть назву банку отримувача</small>
                <small class="error" v-if="$v.recipientBankName.$dirty && !$v.recipientBankName.required">Введіть назву банку отримувача</small>
            </div>
            <div class="form-group">
                <div class="text-label my-2">Код отримувача</div>
                <input :class="['form-control', { invalid: (!$v.recipientCode.required && $v.recipientCode.$error) || !$v.recipientCode.minLength || !$v.recipientCode.maxLength }]" v-model="recipientCode" type="number" :disabled="!editRecipientData">
                <small class="error" v-if="$v.recipientCode.$dirty && !$v.recipientCode.minLength">Введіть код отримувача</small>
                <small class="error" v-if="$v.recipientCode.$dirty && !$v.recipientCode.required">Введіть код отримувача</small>
            </div>
            <div class="form-group">
                <div class="text-label my-2">Найменування отримувача</div>
                <input :class="['form-control', { invalid: (!$v.recipientName.required && $v.recipientName.$error) || (!$v.recipientName.minLength ) }]" v-model="recipientName" type="text" :disabled="!editRecipientData">
                <small class="error" v-if="$v.recipientName.$dirty && !$v.recipientName.minLength">Введіть імʼя особи отримувача</small>
                <small class="error" v-if="$v.recipientName.$dirty && !$v.recipientName.required">Введіть імʼя особи отримувача</small>
            </div>
            <div class="form-group">
                <div class="text-label my-2">Номер картки</div>
                <input :class="['form-control', { invalid: (!$v.recipientBankCard.required && $v.recipientBankCard.$error) || !$v.recipientBankCard.minLength || !$v.recipientBankCard.maxLength }]" v-model="recipientBankCard" type="text" :disabled="!editRecipientData">
                <small class="error" v-if="$v.recipientBankCard.$dirty && !$v.recipientBankCard.minLength">Введіть номер картки отримувача</small>
                <small class="error" v-if="$v.recipientBankCard.$dirty && !$v.recipientBankCard.required">Введіть номер картки отримувача</small>
            </div>
            <div class="form-group">
                <div class="text-label mb-1">Коментар</div>
                <textarea :class="['form-control']" v-model="comment" placeholder="Введіть коментар"></textarea>
            </div>
        </div>
        <div class="col-md-12 dialog-footer d-flex justify-content-around mt-3">
            <el-button class="w-100 font-weight-bold" type="primary" plain @click="dialogVisible = false">Відміна</el-button>
            <el-button class="w-100 font-weight-bold" type="primary" :loading="isUpdate" @click="withdrawMoney">
                Підтвердити
            </el-button>
        </div>
    </el-dialog>
</template>
<script>

import { customMaskMixin, userMixin } from '@/mixin'
import {minValue, maxValue, required, minLength, maxLength, requiredIf} from "vuelidate/lib/validators";
import {createWithdrawalRequest} from "@/api/withdrawalRequest";

export default {
    mixins: [customMaskMixin, userMixin],
    data() {
        return {
            isUpdate: false,
            withdrawSum: null,
            calculatedWithdrawSum: 0,
            comment: null,
            editRecipientData: false,
            recipientAccount: null,
            recipientBankName: null,
            recipientCode: null,
            recipientName: null,
            recipientBankCard: null,
            userId: null,
            dialogVisible: false
        };
    },
    validations: {
        withdrawSum: {
            required,
            minValue: minValue(1),
            maxValue: maxValue(100000),
            allowedSum(value) {
                if (this.checkWithdrawSum(value)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        recipientName: {required, minLength: minLength(2)},
        recipientCode: {required, minLength: minLength(8), maxLength: maxLength(10)},
        recipientAccount: {required, minLength: minLength(2)},
        recipientBankName: {required, minLength: minLength(2)},
        recipientBankCard: {
            required: requiredIf(function (nestedModel) {
                return this.recipientTypeId == 0
            }),
            minLength: minLength(10),
            maxLength: maxLength(19)
        },
    },
    created() {

    },
    mounted() {
        if (!this.userInfo) {
            this.$store.dispatch('GET_USERINFO');
        }
    },
    computed: {
        amount() {
            return this.$store.state.transactionsStore.all.amount;
        },
        // userInfo:  function() {
        //     return this.$store.state.userInfo.userInfo
        // },
    },
    watch: {
        withdrawSum: function (val) {
           // if (this.checkWithdrawSum(val)) {}
            this.calculateSum(val);
        },
        userInfo: function (val) {
            if (val) {
                this.setUserRecipientData();
            }
        },
    },
    methods: {
        setUserRecipientData() {
            if (this.userInfo && this.userInfo?.userInfo) {
                this.recipientAccount = this.userInfo.userInfo.recipientAccount ?? null;
                this.recipientBankName = this.userInfo.userInfo.recipientBankName ?? null;
                this.recipientCode = this.userInfo.userInfo.recipientCode ?? null;
                this.recipientName = this.userInfo.userInfo.recipientName ?? null;
                this.recipientBankCard = this.userInfo.userInfo.recipientBankCard ?? null;
                this.recipientTypeId = this.userInfo.userInfo.recipientTypeId ?? null;
                this.editRecipientData = !(this.recipientAccount && this.recipientCode && this.recipientName);
            }
        },
        allowEdit() {

        },
        checkWithdrawSum(value = this.withdrawSum) {
            return value < parseFloat(this.amount);
        },
        calculateSum(valueSum) {
           return (valueSum - (valueSum/10)).toFixed(2);
        },
        withdrawMoney: async function() {
            if (this.$v.$invalid) {
                this.$v.$touch()

                return
            }
            const recipientData = {
                "recipientAccount": this.recipientAccount,
                "recipientBankName": this.recipientBankName,
                "recipientCode": this.recipientCode,
                "recipientName": this.recipientName,
                "recipientBankCard": this.recipientBankCard ?? null,
            }

            let params = {
                "user_id": this.getUserId(),
                "amount": this.withdrawSum,
                "amount_actual": this.calculateSum(this.withdrawSum),
                "comment": this.comment,
                "data": recipientData
            };

            this.isUpdate = true;

            let response = await createWithdrawalRequest(params)
                .then(response => {

                    if (response.data.status && response.data.status === 'success') {
                        this.$swal('', 'Запит на зняття коштів вдало відправлено', 'success');
                    }

                    if (response.data.error) {
                        this.$swal('', response.data.message, 'error');
                    }

                    this.handleClose();
                    this.withdrawSum = 0;
                    this.isUpdate = false;

                })
                .catch(e => {
                    console.log(e);
                    this.$swal('', 'Щось пішло не так, спробуйте ще раз', 'error');
                    this.handleClose();
                    this.isUpdate = false;
                });
        },
        show: function(userId) {
            this.dialogVisible = true;
            this.userId = userId;
        },
        handleClose: function() {
            this.dialogVisible = false;
            this.userId = null;
        }
    },
}
</script>

<style lang="scss">
.withdraw-balance-popup {
    .form-group {
        margin-bottom: 2px;
        .form-control {
            padding: 16px 10px;
            font-size: 12px;
            &:disabled, &[readonly] {
                background-color: #f6f6f6;
            }
        }
        label {
            font-size: 14px;
        }
        .error{
            font-size: 12px;
            word-break: break-word;
        }
    }
    .el-button {
        font-size: 12px;
    }
    .withdraw-title {
        color: #24282C;
        font-weight: bold;
        font-size: 20px;
    }
    .middle-title {
        font-weight: bold;
        font-size: 15px;
        color: #24282C;
    }
    .text-label {
        font-size: 12px;
        font-weight: bold;
        color: #24282C;
    }
    .btn-edit-recipient {
        position: absolute;
        right: 0;
        margin-right: 15px;
        cursor: pointer;
    }
    .calculate-sum {
        color: #FF7700;
        font-size: 20px;
        font-weight: bold;
    }
    .btn-edit {
        border: 2px solid #409EFF;
        &:hover {
            svg path{
                fill: #fff;
            }
        }
    }
}


</style>
